import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../molecules/BrandModal.css";

export const ReopenModal = ({ toggle, setToggle, onReopen, account }) => {
  const [reason, setReason] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  const close = () => {
    setToggle(false);
    setReason("");
    setShowAdditionalError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setShowAdditionalError(true);
      return;
    }

    close();
    onReopen(account.id, reason);
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Reopen Account</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Please provide a justification for reopening this account.</p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="reopenReason">Justification</Label>
            <Input
              type="textarea"
              id="reopenReason"
              placeholder="Justification text that will be included in email"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) setShowAdditionalError(false);
              }}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary">
              <FontAwesomeIcon icon={faRotateRight} /> Reopen
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
